<template>
  <v-dialog 
    v-model="dialog" 
    max-width="800"
    @click:outside="close_dialog"
  >
    <v-card
      tile
    >
      <v-card-title>แบบฟอร์มแนบประกาศ</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="8">
            <v-select
              v-model="form.type"
              :items="announcement_types"
              item-text="name"
              item-value="id"
              dense
              outlined
              placeholder="ประเภทประกาศ"
              hide-details="auto"
            ></v-select>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="form.no"
              dense
              outlined
              placeholder="เลขที่ประกาศ"
              hide-details="auto"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-text-field
          class="mb-3"
          v-model="form.title"
          dense
          outlined
          placeholder="ชื่อประกาศ"
          hide-details="auto"
        ></v-text-field>
        <v-file-input
          v-model="form.file"
          label="แนบไฟล์ประกาศ"
          outlined
          dense
          hide-details="auto"
        ></v-file-input>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="submit">{{ form_type === 'NEW' ? 'เพิ่ม' : 'แก้ไข' }}</v-btn>
        <v-btn class="error" @click="close_dialog">ยกเลิก</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    form: Object,
    form_type: String,
    announcement_types: Array
  },
  methods: {
    submit() {
      this.$emit('submit', this.form);
    },
    close_dialog() {
      this.$emit('update:dialog', false);
    }
  }
}
</script>